import { Modal } from '../Modal/Modal';
import { VideoPlayer } from '../VideoPlayer/VideoPlayer';

export interface VideoModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  mediaId?: string;
  file?: string;
}

export function VideoModal({
  open,
  onClose,
  title,
  mediaId,
  file,
}: Readonly<VideoModalProps>) {
  return (
    <Modal
      open={open}
      title={title}
      onCancel={onClose}
      footer={null}
      width={960}
      closable
      destroyOnHidden
    >
      {open && <VideoPlayer mediaId={mediaId} file={file} />}
    </Modal>
  );
}
